import { Modal } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useTranslation } from 'react-i18next';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
  p: 4,
};

const ConfirmDeleteModalWindow = ({
  onClose,
  deleteMessage,
  deleteText = 'Delete',
  cancelText = 'Cancel',
  modalTitle,
  open,
  condition,
  setIsOpenModal,
  isDelete = true,
}) => {
  const { t } = useTranslation('translations');

  const deleteMsg = () => {
    setIsOpenModal(false);
    deleteMessage();
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <h4 className="mb-10 text-dark dark:text-white text-center">{t(modalTitle)}</h4>
        <div className="flex justify-between items-center mt-10 space-x-4">
          <button
            className="bg-grey-200 hover:bg-grey-300 text-black py-10 px-20 rounded-lg"
            onClick={onClose}
          >
            {t(cancelText)}
          </button>
          <button
            className={`${isDelete ? 'bg-red-500' : 'bg-green-500'} ${
              isDelete ? 'hover:bg-red-600' : 'hover:bg-green-600'
            } text-white py-10 px-20 rounded-lg`}
            onClick={deleteMsg}
          >
            {t(deleteText)}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmDeleteModalWindow;
